import { render, staticRenderFns } from "./message-context-menu.vue?vue&type=template&id=7b6afb2e&scoped=true&"
import script from "./message-context-menu.vue?vue&type=script&lang=js&"
export * from "./message-context-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6afb2e",
  null
  
)

export default component.exports